import type { GetServerSideProps, GetServerSidePropsResult } from "next/types"

import { ROUTES } from "common/constants/routes"
import { WHITELABEL_GOVERNORS_IDS } from "whitelabel/constants/governorId"
import { getOriginRequest } from "whitelabel/helpers/whitelabel"
import { isWhitelabel } from "whitelabel/hooks/useIsWhiteLabel"
import { getWhiteLabelRoute } from "whitelabel/utils/breadcrumb"

// eslint-disable-next-line @typescript-eslint/ban-types
type Props = {}

function Home() {
  return null
}

export default Home

export const getServerSideProps: GetServerSideProps = async (
  context,
): Promise<GetServerSidePropsResult<Props>> => {
  const origin = getOriginRequest(context)

  if (!origin) {
    return {
      props: {},
    }
  }

  if (isWhitelabel(context)) {
    return {
      redirect: {
        permanent: false,
        destination: getWhiteLabelRoute(
          // @ts-expect-error nothing to do
          ROUTES.governance.id(WHITELABEL_GOVERNORS_IDS[origin]),
        ),
      },
    }
  }

  return {
    props: {},
  }
}
